export default function InvestorOpportunities() {
  const opportunities = [
    {
      icon: 'ri-shield-check-line',
      title: 'QUALIFIED INVESTORS',
      points: [
        'Access to institutional-grade infrastructure investments',
        'Diversified portfolio across multiple sectors and geographies',
        'Long-term value creation through strategic asset development',
        'Transparent reporting and professional fund management'
      ]
    },
    {
      icon: 'ri-building-2-line',
      title: 'INSTITUTIONAL CAPITAL',
      points: [
        'Co-investment opportunities in large-scale projects',
        'Customized investment structures for institutional requirements',
        'Direct access to development pipeline and deal flow',
        'Partnership with experienced operational teams'
      ]
    }
  ];

  return (
    <section className="bg-black relative py-16 sm:py-24 lg:py-32 overflow-hidden">
      {/* Radial spotlight effect */}
      <div className="absolute inset-0 bg-gradient-radial from-yellow-900/10 via-transparent to-transparent"></div>

      <div className="container mx-auto px-4 sm:px-8 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 sm:mb-16 lg:mb-20">
            <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-vip-diamond-line text-3xl sm:text-4xl text-yellow-600"></i>
            </div>
            <h2 className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">INVESTOR OPPORTUNITIES</h2>
            <div className="text-white/75 text-sm sm:text-base font-light leading-relaxed max-w-3xl mx-auto space-y-3 sm:space-y-4">
              <p>
                Ark Capital™ provides opportunities for qualified investors to participate in infrastructure and industrial development projects designed to generate long-term value.
              </p>
              <p>
                Through disciplined investment strategy and careful project selection, we focus on opportunities that combine strong market fundamentals with sustainable growth potential.
              </p>
            </div>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10 mb-10 sm:mb-20">
            {opportunities.map((opp, index) => (
              <div
                key={index}
                className="bg-zinc-900 border-t-[3px] border-yellow-600 p-8 sm:p-12 lg:p-16"
              >
                {/* Icon */}
                <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center mb-6 sm:mb-8">
                  <i className={`${opp.icon} text-4xl sm:text-5xl text-yellow-600`}></i>
                </div>

                {/* Title */}
                <h3 className="text-white text-2xl sm:text-3xl font-bold mb-5 sm:mb-8">
                  {opp.title}
                </h3>

                {/* Points */}
                <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                  {opp.points.map((point, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-white/80 text-sm sm:text-[15px] font-light leading-relaxed">
                      <span className="text-yellow-600 mt-1 flex-shrink-0">●</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>

                {/* Link */}
                <a href="#contact" className="text-yellow-600 font-semibold text-sm tracking-wide hover:text-yellow-500 transition-colors inline-flex items-center gap-2 cursor-pointer">
                  LEARN MORE
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div className="text-center">
            <a
              href="#contact"
              className="inline-block bg-yellow-600 text-black px-10 sm:px-16 py-4 sm:py-5 font-semibold tracking-wide hover:bg-yellow-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              INVESTOR INQUIRIES
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}